import React, { useState } from "react";
import "./StaticLandingPage.css";

// Waitlist Form Component
function WaitlistForm({ formId }: { formId: string }) {
  const [email, setEmail] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError("");

    try {
      const response = await fetch(`https://formspree.io/f/${formId}`, {
        method: 'POST',
        body: JSON.stringify({ email }),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        setEmail("");
        setIsSubmitted(true);
      } else {
        setError("Something went wrong. Please try again.");
      }
    } catch (err) {
      setError("Network error. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="waitlist-container">
      {!isSubmitted ? (
        <>
          <form id="waitlist-form" onSubmit={handleSubmit} className="waitlist-form">
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
              disabled={isSubmitting}
            />
            <button type="submit" disabled={isSubmitting}>
              {isSubmitting ? "Sending..." : "Join Waitlist"}
            </button>
          </form>
          {error && <p className="error-message">{error}</p>}
        </>
      ) : (
        <p className="waitlist-success">
          ✅ You're on the waitlist!
        </p>
      )}
    </div>
  );
}

export default function StaticLandingPage() {
  return (
    <div className="landing-container">
      <div className="landing-inner">
        <header className="landing-header">
          <div className="landing-logo">
            <img
              src="./junago-star-transparent.svg"
              alt="Junago logo"
              className="logo-icon"
            />
            <span className="logo-wordmark">Junago</span>
          </div>
          {/* Login/Signup buttons removed for static version */}
        </header>

        <main className="landing-main">
          <h2 className="landing-title">
            It's not code. It's <span className="hero-wordmark">Junago</span>.
          </h2>
          <p className="landing-subtitle">
            <span className="hero-wordmark">Junago</span> builds AI assistants that know your business — <span style={{ color: '#6ee7b7' }}>trained</span> on your documents.
          </p>
          <p className="landing-subcaption">
            Use them inside Junago — or soon, embed them on your site.
          </p>

          <div className="assistant-card">
            <div className="assistant-input-container">
              <textarea
                placeholder="Describe your assistant's job (e.g., Answer FAQs for my yoga studio)"
                className="assistant-input"
                rows={3}
                readOnly
              />
              <div className="assistant-actions">
                <div className="action-group-left">
                  <div className="upload-button">
                    <span className="plus-icon">+</span>
                  </div>
                </div>
                <button
                  className="submit-button"
                  aria-label="Submit"
                  disabled
                >
                  <span className="arrow-up-icon">↑</span>
                </button>
              </div>
            </div>
          </div>

          <section className="how-it-works">
            <h3>How Junago Works</h3>
            <div className="step-list">
              <div className="step">
                <strong>1. Describe</strong>
                <p>Just type what you want your assistant to do.</p>
              </div>
              <div className="step">
                <strong>2. Upload (optional)</strong>
                <p>Add documents to boost its intelligence.</p>
              </div>
              <div className="step">
                <strong>3. Launch</strong>
                <p>Junago builds and runs your assistant instantly.</p>
              </div>
            </div>
          </section>

          <section className="waitlist-section">
            <h3>Join Our Waitlist</h3>
            <p>Be the first to know when we launch!</p>
            <WaitlistForm formId="mqabpavz" />
          </section>
        </main>
      </div>
    </div>
  );
}
